import axios from 'axios';

export const login = async (credentials) => {
    return await axios.post(
        `${ process.env.VUE_APP_CORE_HOST.replace(/.$/, '2') }/users/login`,
        credentials
    );
};

export const confirmPasswordReset = async (resetPasswordToken, formData) => {
    return await axios.put(`/users/password/${ resetPasswordToken }`, formData);
};

export const requestPasswordReset = async (formData) => {
    return await axios.put('/users/password-reset', formData);
}

export const fetchTdc1Companies = async () => {
    return await axios.get(
        `${ process.env.VUE_APP_CORE_HOST.replace(/.$/, '2') }/companies/tdc1`
    );
}

export const fetchUserPermissions = async () => {
    return await axios.get('/users/permissions');
}

export const fetchUser = async (userId) => {
    return await axios.get(`/users/${userId}`);
}

export const firstLoginFrontPasswordReset = async (formData) => {
    return await axios.put(`/users/first-login-front-password-reset`, formData);
}

export const getUserRoleByToken = async (resetPasswordToken) => {
    return await axios.get(`/users/password-reset/${resetPasswordToken}`);
}
